import { Props_SnippetImage } from './Image.props'

const SnippetImage = (props: Props_SnippetImage) => {
    const { image } = props

    return (
        <section className="snippet-image">
            <div className="snippet-image__container">
                <img
                    loading="lazy"
                    src={image.src?.value}
                    className="snippet-image__image"
                    height="350"
                    width="1130"
                    alt={image.alt?.value ? image.alt.value : ''}
                />
            </div>
        </section>
    )
}

export default SnippetImage